import { Navigate, Outlet } from 'react-router-dom';

import { LOGIN_PATH } from '@constant/routes';
import { useAuth } from '@context/auth-context';

export default function ProtectedRoute() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return <Outlet />;
}
